import type { SystemStyleObject } from "@chakra-ui/react";

// @fencyai/react's <AgentTaskProgress> renders a "copy task id" button the user has no use for,
// with no prop to disable it. It has no class or data-attribute; the only thing distinguishing its
// wrapper is an inline `right: 0` position style — the sole use of `right` anywhere in the package
// (checked against dist/index.js, @fencyai/react@0.1.208). Scope the hide to wherever this is spread
// so it never reaches into unrelated DOM.
export const HIDE_AGENT_TASK_COPY_ID_SX: SystemStyleObject = {
  'div[style*="right: 0"]': { display: "none" },
};
